"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = _interopRequireDefault(require("../ykb-styled-components"));
var _ykbUtils = require("ykb-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var LineContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-k95h9-0"
})(["position:relative;width:", "px;height:", "px;margin-top:2px;overflow:hidden;"], function (props) {
  return props.$width;
}, function (props) {
  return props.$height;
});
var DEFAULT_WIDTH = 30;
var DEFAULT_NUMBER_WIDTH = 10;
var LineCounter = function LineCounter(_ref) {
  var inputRef = _ref.inputRef,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    scrollTop = _ref.scrollTop,
    showLineNumber = _ref.showLineNumber;
  var _useState = (0, _react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.split('\n')) || []),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    lineNumbers = _useState2[0],
    setLineNumbers = _useState2[1];
  var _useState3 = (0, _react.useState)(DEFAULT_WIDTH),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  (0, _react.useEffect)(function () {
    if ((0, _ykbUtils.isNullOrUndefined)(value)) return;
    var lines = (value === null || value === void 0 ? void 0 : value.split('\n')) || [];
    setLineNumbers(lines);
  }, [inputRef, value]);
  var isReverse = true;
  var reversedCount = isReverse ? -1 : 1;
  var defaultTop = 4;
  var top = reversedCount * (scrollTop - defaultTop);
  if (!showLineNumber) return null;
  return /*#__PURE__*/_react.default.createElement(LineContainer, {
    className: "line-counter",
    $width: width,
    $height: inputRef === null || inputRef === void 0 ? void 0 : inputRef.clientHeight
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "line-numbers",
    style: {
      top: top
    }
  }, lineNumbers === null || lineNumbers === void 0 ? void 0 : lineNumbers.map(function (lineNumber, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: index
    });
  })));
};
LineCounter.propTypes = {
  inputRef: _propTypes.default.any.isRequired,
  value: _propTypes.default.any.isRequired,
  scrollTop: _propTypes.default.any
};
var _default = exports.default = LineCounter;